import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataCleansingService } from '../../services/data-cleansing.service';
import { MatTableDataSource } from '@angular/material/table';
import { RulesDetailModel } from '../../models/rules/rules.detail.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GlobalService } from '../../services/global.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { RulesModel } from '../../models/rules/rules.model';
import { AlertComponent } from '../../common/alert/alert.component';
import { Title } from '@angular/platform-browser';
import { RulesLabelModel } from '../../models/rules/rules.label.model';
import { KnnRegressionPopupComponent } from '../knn-regression-popup/knn-regression-popup.component';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-cleansing-rule',
  templateUrl: './cleansing-rule.component.html',
  styleUrls: ['./cleansing-rule.component.css']
})
export class CleansingRuleComponent implements OnInit {

  dataSource = [];
  parameterList: any[];
  selectedParameter;
  isLoading: boolean = false;
  readOnly: boolean = false;
  cleansingRulesList: RulesLabelModel[];
  masterCleansingRulesList: RulesLabelModel[];
  conditionList: string[];
  selectedSequence: number = 0;
  private readonly insufficientRulesData: RulesLabelModel = new RulesLabelModel(0, "Create Blank Entries", "Expected Data Frequency (minute)", "Textbox");

  displayedColumns: string[] = ['cleansingMethod'];
  rulesDataSource: MatTableDataSource<RulesDetailModel>;
  cleansingRuleData: RulesModel;
  iscleansingDataAvailable = true;

  public cleansingRuleForm = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    dataSourceId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tagName: new UntypedFormControl({ value: '', disabled: true }, Validators.required)
  });

  constructor(public dialogRef: MatDialogRef<CleansingRuleComponent>, private readonly dataCleansingService: DataCleansingService, public globalService: GlobalService,
    public fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private readonly titleService: Title) {
    titleService.setTitle('Data Cleansing');
  }

  ngOnInit(): void {
    this.getToken();
  }

  getToken() {
    this.dataCleansingService.getToken().pipe(
      switchMap((data: any) => {
        this.isLoading = true;
        this.cleansingRuleData = new RulesModel();
        this.conditionList = ["<", ">", "<=", ">=", "==", "!=", "Null Values", "Non Numeric", "Insufficient Data"];
        return of(data);
      }),
      switchMap((data) => { this.getDataSources(); return of([]); }),
      switchMap((data) => { this.fetchCleansingRulesList(); return of([]); }),
      switchMap((data) => { this.loadCleansingRulesTableData(); return of([]); }),
      switchMap((data) => { this.getDataSourceParameters(); return of([]); }),
    ).subscribe((error) => {
      console.log(error);
    });
  }

  /**Fetches list of datasources */
  getDataSources() {
    this.dataCleansingService.getDataSources().subscribe((data: any) => {
      this.dataSource = data;
      return of(this.dataSource)
    }, (error: Error) => { this.isLoading = false; });
  }

  /**Fetches all cleansing rules */
  fetchCleansingRulesList() {
    this.dataCleansingService.listAllCleansingRules().subscribe((data: RulesLabelModel[]) => {
      if (this.globalService.isNotNullObject(data) && data.length > 0) {
        this.masterCleansingRulesList = [...data];
        this.listAllCleansingRules();
        this.isLoading = false;
        return of(this.masterCleansingRulesList)
      }
    }, (error: Error) => { this.isLoading = false; });
  }

  loadCleansingRulesTableData() {
    this.iscleansingDataAvailable = false;
    if (this.data.displayType !== 'add') {
      this.cleansingRuleData = this.data.ruleData;
      this.listAllCleansingRules();
      for (let a = 0; a < this.cleansingRuleData.cleansingRules.length; a++) {
        this.checkDuplicateCleansingMethod(this.cleansingRuleData.cleansingRules[a].cleansingMethod);
      }
      if (this.globalService.isNotNullObject(this.cleansingRuleData)) {
        this.cleansingRuleForm.get('dataSourceId').disable();
        this.cleansingRuleForm = new UntypedFormGroup({
          cleansingRuleConfigId: new UntypedFormControl(this.cleansingRuleData.cleansingRuleConfigId),
          dataSourceId: new UntypedFormControl({ value: this.cleansingRuleData.dataSourceId, disabled: true }, Validators.required),
          tagName: new UntypedFormControl({ value: this.cleansingRuleData.tagName, disabled: true }, Validators.required)
        });
        
        this.rulesDataSource = new MatTableDataSource(this.cleansingRuleData.cleansingRules);
        this.rulesDataSource.data.sort((a, b) => a.sequence - b.sequence);
        this.isLoading = false;
      }
    } else {
      this.cleansingRuleForm = this.fb.group({
        dataSourceId: ['', Validators.required],
        tagName: [{ value: '', disabled: true }, Validators.required]
      });
      this.isLoading = false;
    }
  }

  /**Fetches list of selected datasource parameters*/
  getDataSourceParameters() {
    this.isLoading = true;
    this.dataCleansingService.getDataSourceParameters(this.cleansingRuleForm.get('dataSourceId').value).subscribe((data: any): void => {
      if (this.globalService.isNotNullObject(data) && data.length > 0) {
        this.cleansingRuleForm.get('tagName').enable();
        this.parameterList = data;
      }
      this.isLoading = false;
    }, (error: Error) => { this.isLoading = false; });
  }

  /**Triggered when new data source is selected */
  onDataSourceSelected(event) {
    let selectedDataSource = this.cleansingRuleForm.get('dataSourceId').value;
    this.cleansingRuleForm.reset();
    this.cleansingRuleForm.get('dataSourceId').setValue(selectedDataSource);
    this.cleansingRuleData.dataSourceId = selectedDataSource;
    this.getDataSourceParameters();
  }

  /**Triggered when tag is selected */
  onTagNameSelected(event) {
    this.dataCleansingService.listCleansingRulesForSelectedId(this.cleansingRuleForm.get('dataSourceId').value, this.cleansingRuleForm.get('tagName').value)
      .subscribe((data: any): void => {
        if (this.globalService.isNotNullObject(data)) {
          this.globalService.showAlert(AlertComponent, { success: false, message: "Cleansing rules for the parameter " + this.cleansingRuleForm.get('tagName').value + " is already available. Please select a different parameter" });
          let selectedDataSource = this.cleansingRuleForm.get('dataSourceId').value;
          this.cleansingRuleForm.reset();
          this.cleansingRuleForm.get('dataSourceId').setValue(selectedDataSource);
        } else {
          this.cleansingRuleData.tagName = this.cleansingRuleForm.get('tagName').value;
          this.cleansingRuleData.cleansingRules = [];
          this.addNewRule();
        }
      }, (error: Error) => { this.isLoading = false; });
  }

  /**Checks if table should be displayed */
  displayTable() {
    let displayTable: boolean = false;
    if (this.data && this.data.displayType == 'add') {
      displayTable = this.globalService.isNotNullObject(this.cleansingRuleForm) && this.cleansingRuleForm.get('tagName').valid && (this.parameterList.find(element => element.tagName == this.cleansingRuleForm.get('tagName').value));
    } else {
      displayTable = true;
    }
    return displayTable;
  }

  /**Adds a new rule */
  addNewRule() {
    this.cleansingRuleData.cleansingRules.push(new RulesDetailModel());
    this.setSelectedSequence(this.cleansingRuleData.cleansingRules.length);
    for (let i = 0; i < this.cleansingRuleData.cleansingRules.length; i++) {
      this.cleansingRuleData.cleansingRules[i].sequence = i + 1;
      if (i == this.cleansingRuleData.cleansingRules.length - 1) {
        this.cleansingRuleData.cleansingRules[i].cleansingMethod = "Untitled *";
        this.cleansingRuleData.cleansingRules[i].evaluateInfluencingTag = false;
        if (this.data.displayType == 'edit') {
          this.cleansingRuleData.cleansingRules[i].cleansingRuleConfigId = this.data.ruleData.cleansingRuleConfigId;
        }
      }
    }
    this.rulesDataSource = new MatTableDataSource(this.cleansingRuleData.cleansingRules);
  }

  /**Deletes a rule */
  deleteModel() {
    let toBeDeletedMethod: string = this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingMethod;
    this.cleansingRuleData.cleansingRules.splice(this.selectedSequence, 1);
    this.selectedSequence = 0;//To avoid errors in case the selectedSequence was the last element
    for (let i = 0; i < this.cleansingRuleData.cleansingRules.length; i++) {
      this.cleansingRuleData.cleansingRules[i].sequence = i + 1;
    }
    this.checkDuplicateCleansingMethod(toBeDeletedMethod);
    this.rulesDataSource = new MatTableDataSource(this.cleansingRuleData.cleansingRules);
  }

  /**
   * Changes the sequence of the rules
   * @param event
   */
  drop(event: CdkDragDrop<string[]>) {
    let tempData = this.rulesDataSource.data;
    let previousMethodName: string = this.cleansingRuleData.cleansingRules[event.previousIndex].cleansingMethod;
    let currentMethodName: string = this.cleansingRuleData.cleansingRules[event.currentIndex].cleansingMethod;
    moveItemInArray(this.rulesDataSource.data, event.previousIndex, event.currentIndex);
    this.updateSequence(tempData, previousMethodName, currentMethodName);
  }

  /**
   * Updates the sequence number after drop event.
   * @param tempData
   * @param previousMethodName
   * @param currentMethodName
   */
  updateSequence(tempData: RulesDetailModel[], previousMethodName: string, currentMethodName: string) {
    for (let i = 0; i < tempData.length; i++) {
      tempData[i].sequence = i + 1;
    }
    this.rulesDataSource = new MatTableDataSource(tempData);
    this.checkDuplicateCleansingMethod(previousMethodName);
    this.checkDuplicateCleansingMethod(currentMethodName);
    this.listAllCleansingRules();
    this.rulesDataSource.data.sort((a, b) => a.sequence - b.sequence);
  }

  /**Lists all rules */
  listAllCleansingRules() {
    if(this.cleansingRuleData.cleansingRules) {
      if (this.cleansingRuleData.cleansingRules[this.selectedSequence].condition == "Insufficient Data") {
        this.cleansingRulesList = [];
        this.cleansingRulesList.push(this.insufficientRulesData);
      } else {
        this.cleansingRulesList = this.masterCleansingRulesList;
      }
    }
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }

  /**Saves data cleansing rule */
  saveCleansingRule() {
    let rules: RulesModel = this.cleansingRuleData;
    if (this.data.displayType === 'add') {
      rules.createdBy = this.globalService.loggedInUser;
    }
    rules.updatedBy = this.globalService.loggedInUser;
    for (let i = 0; i < rules.cleansingRules.length; i++) {
      rules.cleansingRules[i].sequence = i + 1;
      if (!rules.cleansingRules[i].evaluateInfluencingTag) {
        rules.cleansingRules[i].influencingTag = "";
      }
    }
    this.dataCleansingService.saveCleansingRule(rules).subscribe((data: any): void => {
      this.globalService.showAlert(AlertComponent, { success: true, message: "Rules for " + rules.tagName + " saved successfully." });

      this.onCancelClick(true);
    }, (error: Error) => {
      this.isLoading = false;
      this.dataCleansingService.getToken().subscribe(locData => {
        this.globalService.showAlert(AlertComponent, { success: false, message: "Rules for " + rules.tagName + " could not be saved." });

      });

    });
  }

  /**
   * Sets the selected sequence number
   * @param sequence
   */
  setSelectedSequence(sequence: number) {
    this.selectedSequence = sequence - 1;
    this.listAllCleansingRules();
  }

  /**Checks if cleansing qualifier should be displayed */
  displayCleansingQualifier() {
    let labelName: string = this.getCleansingQualifierLabel();
    let check: boolean = this.globalService.isNotNull(this.cleansingRuleData.cleansingRules[this.selectedSequence]?.cleansingMethod) &&
      (this.cleansingRuleData.cleansingRules[this.selectedSequence]?.cleansingMethod !== "Untitled *") &&
      (labelName?.toLowerCase() !== "hidden");
    return check;
  }

  /**Finds cleansing Qualifier Label Name */
  getCleansingQualifierLabel(): string {
    if (this.cleansingRuleData.cleansingRules[this.selectedSequence].condition == "Insufficient Data") {
      return this.insufficientRulesData.labelName;
    } else {
      return this.cleansingRulesList?.find((element: RulesLabelModel) =>
        element.cleansingMethod == this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingMethod)?.labelName;
    }
  }

  /**Checks if add button should be disabled */
  disableAddBtn() {
    let untitledMethod: RulesDetailModel = this.cleansingRuleData.cleansingRules?.find((ele: RulesDetailModel) => ele.cleansingMethod == "Untitled *");
    let check: boolean = this.globalService.isNotNullObject(untitledMethod) || this.cleansingRuleData.cleansingRules?.length > 5 ||
      (this.cleansingRuleData.cleansingRules && (!this.globalService.isNotNull(this.cleansingRuleData.cleansingRules[this.selectedSequence].condition) ||
        (!["Null Values", "Non Numeric", "Insufficient Data"].includes(this.cleansingRuleData.cleansingRules[this.selectedSequence].condition) &&
          !this.globalService.isNotNull(this.cleansingRuleData.cleansingRules[this.selectedSequence].value?.toString())))) ||
      (this?.cleansingRuleData?.cleansingRules && this?.cleansingRuleData?.cleansingRules[this.selectedSequence]?.evaluateInfluencingTag &&
        !this.globalService.isNotNull(this.cleansingRuleData.cleansingRules[this.selectedSequence].influencingTag)) ||
      (this.cleansingRuleData.cleansingRules && this.displayCleansingQualifier() &&
        !this.globalService.isNotNull(this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingQualifier));
    return check;
  }

  /**
   * Checks if duplicate cleansing method exists
   * @param cleansingMeth
   */
  checkDuplicateCleansingMethod(cleansingMeth: string) {
    let dupMethod: RulesDetailModel[] = this.cleansingRuleData.cleansingRules?.filter((ele: RulesDetailModel) => ele.cleansingMethod == cleansingMeth);
    if (dupMethod.length > 1) {
      for (let i = 0; i < dupMethod.length; i++) {
        dupMethod[i].cleansingMethodModified = dupMethod[i].cleansingMethod.concat(" (", (i + 1).toString(), ")");
      }
    } else {
      for (let i = 0; i < dupMethod.length; i++) {
        dupMethod[i].cleansingMethodModified = dupMethod[i].cleansingMethod;
      }
    }
    if (!this.displayCleansingQualifier()) {
      this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingQualifier = "";
    }
  }

  /**Display or hide the values based on condition selected */
  displayHideValue() {
    this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingMethod = "Untitled *";
    this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingMethodModified = "";
    this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingQualifier = "";
    if (["Non Numeric", "Null Values", "Insufficient Data"].includes(this.cleansingRuleData.cleansingRules[this.selectedSequence].condition)) {
      this.cleansingRuleData.cleansingRules[this.selectedSequence].value = "";
    }
    this.listAllCleansingRules();
  }

  /**Returns true if text value field should be displayed, else false */
  displayTextFieldValue() {
    let check: boolean = ["==", "!="].includes(this.cleansingRuleData.cleansingRules[this.selectedSequence].condition);
    return check;
  }

  addKnnDependantVariables() {
    let dataToPass = {
      parameterList: this.parameterList,
      cleansingQualifier: this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingQualifier
    };
    this.globalService.openModelWindowSmall(this.updateQualifierAfterChange, this, KnnRegressionPopupComponent, dataToPass);
  }

  updateQualifierAfterChange(thisRef: CleansingRuleComponent, result) {
    thisRef.cleansingRuleData.cleansingRules[thisRef.selectedSequence].cleansingQualifier = result.cleansingQualifier;
  }

  changeEvaluateTag() {
    this.cleansingRuleData.cleansingRules[this.selectedSequence].condition = "";
    this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingMethod = "Untitled *";
    this.cleansingRuleData.cleansingRules[this.selectedSequence].cleansingQualifier = "";
    if (this.cleansingRuleData.cleansingRules[this.selectedSequence].evaluateInfluencingTag) {
      this.conditionList = ["<", ">", "<=", ">=", "==", "!=", "Null Values", "Non Numeric"];
    } else {
      this.conditionList = ["<", ">", "<=", ">=", "==", "!=", "Null Values", "Non Numeric", "Insufficient Data"];
    }
  }
}
